require("../src/javascripts/fontawesome/solid.min");
require("../src/javascripts/fontawesome/regular.min");
require("../src/javascripts/fontawesome/brands.min");
require("../src/javascripts/fontawesome/fontawesome.min");
